import React from 'react'
import { Link } from 'react-router-dom'

import {
  iconCounterargument,
  iconEvidence,
  iconReasoning
} from 'modules/ui/assets'
import { Button } from 'modules/ui'
import { withTheme } from 'modules/util'
import EvidenceExplained from './EvidenceExplained'

import helpTheme from './theme.scss'

export function Help({ theme }) {
  return (
    <section className={theme.help}>
      <header className={theme.header}>
        <img
            alt='evidence'
            className={theme.evidenceIcon}
            src={iconEvidence} />

        <img
            alt='reasoning'
            className={theme.reasoningIcon}
            src={iconReasoning} />

        <img
            alt='counterargument'
            className={theme.counterargumentIcon}
            src={iconCounterargument} />

        <h1 className={theme.heading}>
          Build Your Argument
        </h1>
      </header>

      <EvidenceExplained theme={theme} />

      <div className={theme.caption}>
        <p>
            Drag the <strong>Evidence </strong>
            button on the picture to explain your <strong>Claim</strong>.
        </p>

        <p>
            Use <strong>Reasoning </strong>
            to support your <strong>Evidence</strong>.
        </p>

        <p>
            Add a <strong>Counterargument </strong>
            to the <strong>Evidence</strong> you want to argue against.
        </p>
      </div>

      <Link replace className={theme.action} to='./'>
        <Button
            primary
            raised
            icon='arrow_forward' />
      </Link>
    </section>
  )
}

export default withTheme(helpTheme, Help)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Builder/Help/index.js